<span
  [autoClose]="true"
  dropdown
  (onShown)="onDropdownShown()"
  class="onboarding-validInfo block-hint info-icon-container"
  *ngIf="message"
>
  <button dropdownToggle type="button" class="info-icon-toggle" [ngClass]="cls">
    <img
      *ngIf="iconName; else infoIcon"
      appDisableRightClick
      appMobileOptimization
      [originalUrl]="iconName ?? '../assets/images/svg/ic-pass-info.svg'"
      [src]="iconName ?? '../assets/images/svg/ic-pass-info.svg'"
      [format]="'webp'"
      alt="info"
      [height]="height"
      [width]="width"
      loading="lazy"
      decoding="async"
    />
    <ng-template #infoIcon>
      <em
        [class]="iconInfoClass || 'icon-liteic-pass-info'"
        [ngStyle]="{'font-size.px': height ? height : 18}"
      ></em>
    </ng-template>
  </button>
  <div
    *dropdownMenu
    class="dropdown-menu"
    role="menu"
    [ngClass]="isSpaceAvailableOnLeft"
  >
    <p [innerHTML]="formattedMessage" class="message info-message"></p>
  </div>
</span>
